export enum orderStatusApproveRejet {
    all=0,
    approved=1,
    pending=2,
    reject=3,
    comment=4,
    IN_PROGRESS=6,
    REVIEW_OFFER=8,
    IN_REVIEW=9,
    REFUSED=10,
  }
  
  export enum statusApproveRejet {
    all=1,
    pending=2,
    reject=6,
    approved=8,
    comment=9,
}